import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { t } from 'i18next';

const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      id="scroll-to-top-button"
      aria-label={t('scrollToTop')}
      onClick={scrollToTop}
      className={`fixed bottom-18 sm:bottom-20 right-4 p-3 sm:p-4 rounded-full transition-all duration-300 z-50 ${
        isVisible ? 'scale-100' : 'scale-0'
      }`}
      style={{
        backgroundColor: 'var(--button-bg-color)',
        color: 'var(--button-text-color)',
        border: '1px solid var(--color-white)',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--button-hover-bg-color)')}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--button-bg-color)')}
    >
      <ArrowUp className="w-6 h-6" />
    </button>
  );
};

export default ScrollToTopButton;
